export default {
    bindings: {
        flag: '<',
        onEnable: '&',
        onDisable: '&',
        labelEnabled: '@',
        labelDisabled: '@',
        iconEnabled: '@',
        iconDisabled: '@',
    },
    controller: function () {
        this.getLabel = () => this.flag ? this.labelEnabled : this.labelDisabled;
        this.getIcon = () => this.flag ? this.iconEnabled : this.iconDisabled;
        this.action = () => this.flag ? this.onDisable() : this.onEnable();
    },
    template: `
        <md-button
            class="md-icon-button"
            translate-attr="{'aria-label': $ctrl.getLabel(), 'title': $ctrl.getLabel()}"
            role="button"
            tabindex="0"
            ng-click="$ctrl.action()"
            aria-pressed="{{ $ctrl.flag }}">
            <md-icon><img ng-src="{{ $ctrl.getIcon() }}"></md-icon>
        </md-button>
    `,
};
